import { httpPut, httpPost } from "@/services/apiService";

export const clientModule = {
    state: () => ({
        selectedClient: null,
        name: null,
        email: null,
        phone: null,
        processedDiscounts: []
    }),
    mutations: {
        setSelectedClient(state, newValue) {
            state.selectedClient = newValue;
        },
        setName(state, newValue) {
            state.name = newValue;
        },
        setEmail(state, newValue) {
            state.email = newValue;
        },
        setPhone(state, newValue) {
            state.phone = newValue;
        },
        setProccessedDiscounts(state, newValue) {
            state.processedDiscounts = newValue;
        },
    },
    actions: {
        async updateClientData({ state }, data) {
            const processed = {
                ...data,
                discounts: state.processedDiscounts
            }

            const { data: resData } = await httpPut("/clientes/" + data.id, { data: processed });
            (resData?.message);
        },
        async getDiscounts({ state, commit }) {
            const { data } = await httpPost("/clientes/client-discounts", {
                data: { id: state.selectedClient?.id },
            }).catch((err) => {
                console.error("Could not obtain discounts.");
                return;
            });

            commit("setProccessedDiscounts", data?.descuentos);
            (`Descuentos de ${state.selectedClient.attributes.nombre}`, state.processedDiscounts);
        }
    }
}